export enum CheckboxDisplay {
  stacked = 'stacked',
  inline = 'inline'
}
